/** Metadata registry mapping step question types to labels and icons. */
import {
  ListChecks,
  Type,
  ToggleLeft,
  TextCursorInput,
  ArrowUpDown,
  Layers,
  Network,
  Focus,
  Tag,
  Hash,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface QuestionTypeMeta {
  value: string;
  shortLabel: string;
  label: string;
  icon: LucideIcon;
}

export const QUESTION_TYPE_META: QuestionTypeMeta[] = [
  { value: 'mcq', shortLabel: 'MCQ', label: 'Multiple Choice', icon: ListChecks },
  { value: 'text', shortLabel: 'Text', label: 'Short Answer', icon: Type },
  { value: 'true_false', shortLabel: 'T / F', label: 'True / False', icon: ToggleLeft },
  { value: 'cloze', shortLabel: 'Fill', label: 'Fill in the Blanks', icon: TextCursorInput },
  { value: 'ranking', shortLabel: 'Rank', label: 'Ranking', icon: ArrowUpDown },
  { value: 'classify', shortLabel: 'Sort', label: 'Classify', icon: Layers },
  { value: 'cloze_diagram', shortLabel: 'Diagram', label: 'Diagram Blanks', icon: Network },
  { value: 'image_hotspot', shortLabel: 'Hotspot', label: 'Image Hotspot', icon: Focus },
  { value: 'cloze_image', shortLabel: 'Label', label: 'Label Image', icon: Tag },
  { value: 'numeric', shortLabel: 'Num', label: 'Numeric', icon: Hash },
];

/** All question type values (excludes 'info' which isn't revisable). */
export const ALL_QUESTION_TYPES = QUESTION_TYPE_META.map((qt) => qt.value);

export function getQuestionTypeMeta(type: string): QuestionTypeMeta | undefined {
  return QUESTION_TYPE_META.find((qt) => qt.value === type);
}
